<template>
  <div>

    <TextReplacementSearch />

    <v-row>
      <v-col cols="12">
        <v-btn dense :color="'primary'" @click="addTextReplacement()">
          Add Text Replacement
        </v-btn>
      </v-col>
    </v-row>

    <v-data-table
      :items="text_replacements"
      hide-default-footer
      class="sticky mt-5"
      :disable-sort="true"
      :headers="headers"
      :items-per-page="-1"
    >
      <template v-slot:item="{ item }">
      <tr>
          <!-- Row Name -->
          <td>
            <v-list-item dense class="px-0">
              <v-list-item-content>
                <v-list-item-title class="primary--text font-weight-black">
                  {{ item.key }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </td>
          <td>
            <v-list-item dense class="px-0">
              <v-list-item-content>
                <v-list-item-title class="text-wrap">
                  {{ item.replacement }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </td>
          <td>
            <v-list-item dense class="px-0">
              <v-list-item-content>
                <v-list-item-title>
                  <v-btn dense icon @click="updateTextReplacement(item.id, item.key, item.replacement)">
                    <v-icon
                      medium
                      :color="'primary'"
                    >
                      mdi-pen
                    </v-icon>
                  </v-btn>
                  <v-btn dense icon @click="deleteTextReplacement(item.id, item.key)">
                    <v-icon
                      medium
                      :color="'error'"
                    >
                      mdi-trash-can
                    </v-icon>
                  </v-btn>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </td>
        </tr>
      </template>
    </v-data-table>

    <v-row v-if="last_page > 1" class="mt-5">
      <v-col cols="3" align="left">
        <v-btn
          depressed
          rounded
          color="primary"
          class="mx-2 px-4 text-none"
          @click="togglePrev()"
          :disabled="page == 1"
        >
          Prev
        </v-btn>
      </v-col>
      <v-col cols="6" align="center">
        Page {{ page }} / {{ last_page }}
      </v-col>
      
      <v-col cols="3" align="right">
        <v-btn
          depressed
          rounded
          color="primary"
          class="mx-2 px-4 text-none"
          @click="toggleNext()"
          :disabled="last_page == page"
        >
          Next
        </v-btn>
      </v-col>
    </v-row>

    <TextReplacementFormDialog 
      :showDialog="showDialog" 
      :type="type" 
      ref="trDialog"/>

    <TextReplacementDeleteDialog :showDialog="showDeleteDialog" ref="trDeleteDialog"/>

  </div>
</template>

<script>
import TextReplacementDeleteDialog from './TextReplacement/TextReplacementDeleteDialog.vue';
import TextReplacementFormDialog from './TextReplacement/TextReplacementFormDialog.vue';
import TextReplacementSearch from './TextReplacement/TextReplacementSearch.vue';
export default {
  name: "TextReplacement",
  components: { TextReplacementFormDialog, TextReplacementDeleteDialog, TextReplacementSearch },
  data() {
    return {
      headers: [
        { text: "Key", value: "key", width: "100px" },
        { text: "Text Value", value: "text", class: "grey--text text--darken-2" },
        { text: "", value: "", class: "", width: "100px" },
      ],
      page: 1,
      per_page: 20,
      showDialog: false,
      search: '',
      type: '',
      showDeleteDialog: false
    };
  },
  computed: {
    text_replacements() { return this.$store.getters['textreplacement/text_replacements'] },
    last_page () { return this.$store.getters['textreplacement/last_page'] }
  },
  async mounted() {
    let params = { per_page: this.per_page, page: this.page, search: '' };
    await this.$store.dispatch("textreplacement/fetchTextReplacements", params);
  },
  methods: {
    async searchText () {
      let params = { per_page: this.per_page, page: this.page, search: this.search };
      await this.$store.dispatch("textreplacement/fetchTextReplacements", params);
    },
    addTextReplacement() {
      this.$refs.trDialog.create();
      this.type = "add";
      this.showDialog = true;
    },
    updateTextReplacement (id, key, replacement) {
      this.type = "update";
      this.showDialog = true;
      this.$refs.trDialog.update(id, key, replacement);
    },
    deleteTextReplacement (id, key) {
      this.$refs.trDeleteDialog.init(id, key);
      this.showDeleteDialog = true;
    },
    executeSearch (search) {
      this.search = search;
      this.page = 1;
      this.searchText();
    },
    toggleNext () {
      this.page++;
      this.searchText();
    },
    togglePrev () {
      this.page--;
      this.searchText();
    }
  }
};
</script>